<lib-dark-section [titleKey]="titleKey()" [headingId]="headingId()" [narrow]="true">
  <dl class="faq">
    @for (item of items(); track item.questionKey) {
      <div class="faq__item">
        <dt class="faq__question">{{ item.questionKey | translate }}</dt>
        <dd class="faq__answer">{{ item.answerKey | translate }}</dd>
      </div>
    }
  </dl>
</lib-dark-section>
